// 'use client';

// import React, { useState, useEffect } from 'react';
// import {
//   Drawer, Box, Typography, Autocomplete, TextField,
//   Slider, Button, Divider, RadioGroup, FormControlLabel, Radio,
// } from '@mui/material';
// import { useDispatch, useSelector } from 'react-redux';
// import { setFilters } from '../../../../src/store/Newslices/filterSlice';
// import { httpinstance } from '../../../axios/api';

// const DEFAULT_CATEGORIES = ['All', 'EXPRESS', 'STANDARD', 'GENERAL'];

// const CATEGORY_LABELS = {
//   All: 'All',
//   EXPRESS: 'Express',
//   STANDARD: 'Standard',
//   GENERAL: 'General',
// };

// const SORT_OPTIONS = [
//   { value: 'default',        label: 'Default',        icon: '≡' },
//   { value: 'cheapest_total', label: 'Cheapest total',  icon: '₹' },
//   { value: 'cheapest_kg',    label: 'Cheapest /kg',   icon: '⚖' },
//   { value: 'fastest',        label: 'Fastest',         icon: '⚡' },
//   { value: 'slowest',        label: 'Slowest',         icon: '⏱' },
// ];

// const FilterForm = ({ open, onClose }) => {
//   const dispatch = useDispatch();
//   const filtersdata    = useSelector((state) => state?.filter?.filterdata);
//   const appliedFilters = useSelector((state) => state?.filter?.filters);

//   const airlines =
//     filtersdata?.carriers?.map((carrier, index) => ({
//       id: index + 1,
//       name: typeof carrier === 'string' ? carrier : carrier?.name,
//       carrcode: carrier?.carrcode || carrier,
//     })) || [];

//   const stoppages =
//     filtersdata?.stops?.map((stop, index) => ({
//       id: index + 1,
//       label: stop,
//     })) || [];

//   // Safe slider bounds — guard undefined and min===max (zero-range = non-draggable)
//   const hasSliderData =
//     filtersdata?.ratePerKiloRange?.min != null &&
//     filtersdata?.ratePerKiloRange?.max != null;

//   const rateMin     = filtersdata?.ratePerKiloRange?.min ?? 0;
//   const rateMaxRaw  = filtersdata?.ratePerKiloRange?.max ?? 0;
//   const rateMax     = rateMaxRaw <= rateMin ? rateMin + 1 : rateMaxRaw;

//   const priceMin    = filtersdata?.priceRange?.min ?? 0;
//   const priceMaxRaw = filtersdata?.priceRange?.max ?? 0;
//   const priceMax    = priceMaxRaw <= priceMin ? priceMin + 100 : priceMaxRaw;

//   const durMin      = Math.floor((filtersdata?.travelTimeRange?.min ?? 0) / 60);
//   const durMaxRaw   = Math.ceil((filtersdata?.travelTimeRange?.max ?? 0) / 60);
//   const durMax      = durMaxRaw <= durMin ? durMin + 1 : durMaxRaw;

//   // ===== State =====
//   const [selectedAirlines, setSelectedAirlines] = useState([]);
//   const [selectedCategory, setSelectedCategory] = useState('All');
//   const [selectedStops, setSelectedStops]        = useState([]);
//   const [rateRange, setRateRange]                = useState([0, 1]);
//   const [priceRange, setPriceRange]              = useState([0, 100]);
//   const [durationRange, setDurationRange]        = useState([0, 1]);
//   const [selectedSort, setSelectedSort]          = useState('default');

//   const [serviceTypes, setServiceTypes] = useState([]);

//   const fetchServices = async () => {
//     if (selectedCategory === 'All') {
//       setServiceTypes([]);
//       return;
//     }
//     try {
//       const res = await httpinstance.get(`/service-type/${selectedCategory}`);
//       const fetched = res.data?.data?.data;
//       setServiceTypes(Array.isArray(fetched) ? fetched : []);
//     } catch (err) {
//       console.error('Failed to fetch services:', err);
//       setServiceTypes([]);
//     }
//   };

//   useEffect(() => {
//     if (open) fetchServices();
//   }, [open, selectedCategory]);

//   // Restore state when drawer opens. Depends only on open/hasSliderData so that
//   // background filterdata streaming updates never reset the user's in-progress selection.
//   useEffect(() => {
//     if (!open || !hasSliderData) return;

//     if (appliedFilters?.filtersset) {
//       // Restore previously applied slider ranges
//       setRateRange([
//         appliedFilters.ratePerKg?.min  ?? rateMin,
//         appliedFilters.ratePerKg?.max  ?? rateMax,
//       ]);
//       setPriceRange([
//         appliedFilters.totalPrice?.min ?? priceMin,
//         appliedFilters.totalPrice?.max ?? priceMax,
//       ]);
//       setDurationRange([
//         appliedFilters.journeyDuration?.minHours ?? durMin,
//         appliedFilters.journeyDuration?.maxHours ?? durMax,
//       ]);

//       // Restore stops — applied filter stores labels, match back to stoppages objects
//       const restoredStops = appliedFilters.stops?.length
//         ? stoppages.filter((s) => appliedFilters.stops.includes(s.label))
//         : [];
//       setSelectedStops(restoredStops);

//       // Restore airlines — applied filter stores names, match back to airline objects
//       const restoredAirlines = appliedFilters.airlines?.length
//         ? airlines.filter((a) => appliedFilters.airlines.includes(a.name))
//         : [];
//       setSelectedAirlines(restoredAirlines);

//       setSelectedCategory(appliedFilters.category ?? 'All');
//       setSelectedSort(appliedFilters.sortBy ?? 'default');
//     } else {
//       // No previous filters — initialize everything to full range
//       setRateRange([rateMin, rateMax]);
//       setPriceRange([priceMin, priceMax]);
//       setDurationRange([durMin, durMax]);
//       setSelectedStops([]);
//       setSelectedAirlines([]);
//       setSelectedCategory('All');
//       setSelectedSort('default');
//     }
//   // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [open, hasSliderData]);

//   const getFilteredServiceNames = () => {
//     if (!Array.isArray(serviceTypes) || serviceTypes.length === 0) return [];
//     if (selectedCategory === 'All') return serviceTypes.map((s) => s.servicename);
//     return serviceTypes
//       .filter((s) => s.category === selectedCategory)
//       .map((s) => s.servicename);
//   };

//   const availableCategories = DEFAULT_CATEGORIES;

//   const handleApplyFilters = () => {
//     // Only treat a range as an active filter when the user actually narrowed it.
//     // Storing the full-range snapshot is fragile: streaming rates keep widening the
//     // live bounds, so an un-narrowed snapshot would later look "changed" and surface a
//     // phantom chip. null = full range → no chip, no filtering.
//     const rateNarrowed  = rateRange[0]     > rateMin  || rateRange[1]     < rateMax;
//     const priceNarrowed = priceRange[0]    > priceMin || priceRange[1]    < priceMax;
//     const durNarrowed   = durationRange[0] > durMin   || durationRange[1] < durMax;

//     const appliedFilters = {
//       filtersset      : true,
//       airlines        : selectedAirlines?.map((a) => a?.name),
//       services        : getFilteredServiceNames(),
//       category        : selectedCategory === 'All' ? null : selectedCategory,
//       stops           : selectedStops.map((s) => s?.label),
//       ratePerKg       : rateNarrowed  ? { min: rateRange[0],  max: rateRange[1] }  : null,
//       totalPrice      : priceNarrowed ? { min: priceRange[0], max: priceRange[1] } : null,
//       journeyDuration : durNarrowed   ? { minHours: durationRange[0], maxHours: durationRange[1] } : null,
//       sortBy          : selectedSort === 'default' ? null : selectedSort,
//     };
//     dispatch(setFilters(appliedFilters));
//     onClose();
//   };

//   const handleResetFilters = () => {
//     setSelectedAirlines([]);
//     setSelectedCategory('All');
//     setSelectedStops([]);
//     setRateRange([rateMin, rateMax]);
//     setPriceRange([priceMin, priceMax]);
//     setDurationRange([durMin, durMax]);
//     setSelectedSort('default');
//     dispatch(setFilters({
//       filtersset      : false,
//       airlines        : [],
//       services        : [],
//       category        : null,
//       stops           : [],
//       ratePerKg       : null,
//       totalPrice      : null,
//       journeyDuration : null,
//       sortBy          : null,
//     }));
//     onClose();
//   };

//   // ===== UI =====
//   return (
//     <Drawer
//       anchor="right"
//       open={open}
//       onClose={(event, reason) => {
//         if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
//         onClose();
//       }}
//       sx={{
//         '& .MuiDrawer-paper': {
//           width: { xs: '100%', sm: 400 },
//           padding: 3,
//           backgroundColor: '#ffffff',
//           overflowY: 'auto',
//         },
//       }}
//     >
//       <Box>

//         {/* ── Airline Section ── */}
//         <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 9 }}>
//           <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>
//             Airline
//           </Typography>
//         </Box>

//         <Autocomplete
//           multiple
//           options={airlines}
//           getOptionLabel={(option) => option?.name}
//           value={selectedAirlines}
//           onChange={(e, v) => setSelectedAirlines(v)}
//           isOptionEqualToValue={(o, v) => o?.id === v?.id}
//           renderInput={(params) => (
//             <TextField
//               {...params}
//               placeholder="Select airlines"
//               size="small"
//               inputProps={{ ...params.inputProps, readOnly: true }}
//             />
//           )}
//         />

//         <Divider sx={{ my: 2 }} />

//         {/* ── Service Type Section ── */}
//         <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>
//           Services
//         </Typography>

//         <RadioGroup
//           value={selectedCategory}
//           onChange={(e) => {
//             e.stopPropagation();
//             setSelectedCategory(e.target.value);
//           }}
//         >
//           {availableCategories.map((cat) => (
//             <FormControlLabel
//               key={cat}
//               value={cat}
//               control={
//                 <Radio
//                   size="small"
//                   sx={{ color: '#ffaf00', '&.Mui-checked': { color: '#ffaf00' } }}
//                 />
//               }
//               label={<Typography variant="body2">{CATEGORY_LABELS[cat] ?? cat}</Typography>}
//             />
//           ))}
//         </RadioGroup>

//         <Divider sx={{ my: 2 }} />

//         {/* ── Sort Results By Section ── */}
//         <Typography variant="subtitle2" sx={{ mb: 1.5, fontWeight: 600 }}>
//           Sort Results By
//         </Typography>
//         <Box
//           sx={{
//             display: 'grid',
//             gridTemplateColumns: '1fr 1fr',
//             gap: '8px',
//             mb: 0.5,
//           }}
//         >
//           {SORT_OPTIONS.map((opt) => {
//             const isSelected = selectedSort === opt.value;
//             return (
//               <Box
//                 key={opt.value}
//                 onClick={() => setSelectedSort(opt.value)}
//                 sx={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   gap: '8px',
//                   padding: '8px 10px',
//                   border: isSelected ? '2px solid #ffaf00' : '1.5px solid #e0e0e0',
//                   borderRadius: '8px',
//                   backgroundColor: isSelected ? '#fff9eb' : 'white',
//                   cursor: 'pointer',
//                   transition: 'border-color 0.08s, background-color 0.08s',
//                   '&:hover': { borderColor: '#ffaf00', backgroundColor: '#fff9eb' },
//                   userSelect: 'none',
//                 }}
//               >
//                 {/* Radio dot */}
//                 <Box
//                   sx={{
//                     width: 16,
//                     height: 16,
//                     borderRadius: '50%',
//                     border: isSelected ? '2px solid #ffaf00' : '2px solid #bbb',
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     flexShrink: 0,
//                     transition: 'border-color 0.08s',
//                   }}
//                 >
//                   {isSelected && (
//                     <Box
//                       sx={{
//                         width: 8,
//                         height: 8,
//                         borderRadius: '50%',
//                         backgroundColor: '#ffaf00',
//                       }}
//                     />
//                   )}
//                 </Box>
//                 {/* Icon */}
//                 <Typography
//                   sx={{
//                     fontSize: '14px',
//                     lineHeight: 1,
//                     flexShrink: 0,
//                     color: isSelected ? '#856404' : '#888',
//                   }}
//                 >
//                   {opt.icon}
//                 </Typography>
//                 {/* Label */}
//                 <Typography
//                   variant="caption"
//                   sx={{
//                     fontSize: '0.72rem',
//                     fontWeight: isSelected ? 700 : 400,
//                     color: isSelected ? '#856404' : '#444',
//                     lineHeight: 1.2,
//                   }}
//                 >
//                   {opt.label}
//                 </Typography>
//               </Box>
//             );
//           })}
//         </Box>

//         <Divider sx={{ my: 2 }} />

//         {/* ── Stops Section ── */}
//         <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>
//           Stops
//         </Typography>

//         <Autocomplete
//           multiple
//           options={stoppages}
//           getOptionLabel={(option) => option?.label}
//           value={selectedStops}
//           onChange={(e, v) => setSelectedStops(v)}
//           isOptionEqualToValue={(o, v) => o?.id === v?.id}
//           renderInput={(params) => (
//             <TextField
//               {...params}
//               placeholder="Select stops"
//               size="small"
//               inputProps={{ ...params.inputProps, readOnly: true, style: { cursor: 'pointer' } }}
//             />
//           )}
//         />

//         <Divider sx={{ my: 2 }} />

//         {/* ── Rate/kg Slider ── */}
//         <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//           <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>Rate/kg</Typography>
//           <Box sx={{ backgroundColor: '#f7f8f9', borderRadius: 2, px: 1.5, py: 0.3 }}>
//             <Typography variant="caption" sx={{ color: 'black', fontWeight: 500 }}>
//               Rs/kg {rateRange[0].toFixed(2)} to Rs/kg {rateRange[1].toFixed(2)}
//             </Typography>
//           </Box>
//         </Box>
//         <Slider
//           value={rateRange}
//           sx={{ color: '#ffaf00' }}
//           onChange={(_, v) => setRateRange(v)}
//           min={rateMin}
//           max={rateMax}
//           step={0.01}
//           disabled={!hasSliderData}
//           valueLabelDisplay="auto"
//         />
//         <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: -1 }}>
//           <Typography variant="caption" color="text.secondary">Rs/kg {rateMin.toFixed(2)}</Typography>
//           <Typography variant="caption" color="text.secondary">Rs/kg {rateMax.toFixed(2)}</Typography>
//         </Box>

//         <Divider sx={{ my: 2 }} />

//         {/* ── Total Price Slider ── */}
//         <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//           <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>Total Price</Typography>
//           <Box sx={{ backgroundColor: '#f7f8f9', borderRadius: 2, px: 1.5, py: 0.3 }}>
//             <Typography variant="caption" sx={{ color: 'black', fontWeight: 500 }}>
//               {priceRange[0].toLocaleString('en-IN')} Rs to {priceRange[1].toLocaleString('en-IN')} Rs
//             </Typography>
//           </Box>
//         </Box>
//         <Slider
//           sx={{ color: '#ffaf00' }}
//           value={priceRange}
//           onChange={(_, v) => setPriceRange(v)}
//           min={priceMin}
//           max={priceMax}
//           step={100}
//           disabled={!hasSliderData}
//           valueLabelDisplay="auto"
//         />
//         <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: -1 }}>
//           <Typography variant="caption" color="text.secondary">{priceMin.toLocaleString('en-IN')} Rs</Typography>
//           <Typography variant="caption" color="text.secondary">{priceMax.toLocaleString('en-IN')} Rs</Typography>
//         </Box>

//         <Divider sx={{ my: 2 }} />

//         {/* ── Journey Duration Slider ── */}
//         <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//           <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>Journey Duration</Typography>
//           <Box sx={{ backgroundColor: '#f7f8f9', borderRadius: 2, px: 1.5, py: 0.3 }}>
//             <Typography variant="caption" sx={{ color: 'black', fontWeight: 500 }}>
//               {durationRange[0]}h to {durationRange[1]}h
//             </Typography>
//           </Box>
//         </Box>
//         <Slider
//           sx={{ color: '#ffaf00' }}
//           value={durationRange}
//           onChange={(_, v) => setDurationRange(v)}
//           min={durMin}
//           max={durMax}
//           step={1}
//           disabled={!hasSliderData}
//           valueLabelDisplay="auto"
//         />
//         <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: -1 }}>
//           <Typography variant="caption" color="text.secondary">{durMin}h</Typography>
//           <Typography variant="caption" color="text.secondary">{durMax}h</Typography>
//         </Box>

//         {/* ── Action Buttons ── */}
//         <Box sx={{ display: 'flex', gap: 2, mt: 4 }}>
//           <Button
//             variant="outlined"
//             sx={{ color: 'black', borderColor: 'black' }}
//             fullWidth
//             onClick={handleResetFilters}
//           >
//             Reset
//           </Button>
//           <Button
//             variant="contained"
//             sx={{ backgroundColor: '#ffaf00', color: 'white' }}
//             fullWidth
//             onClick={handleApplyFilters}
//           >
//             Apply Filters
//           </Button>
//         </Box>

//       </Box>
//     </Drawer>
//   );
// };

// export default FilterForm;




'use client';

import React, { useState, useEffect } from 'react';
import {
  Box, Typography, Autocomplete, TextField,
  Slider, Button, Divider, RadioGroup, FormControlLabel, Radio,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { setFilters } from '../../../../src/store/Newslices/filterSlice';
import { httpinstance } from '../../../axios/api';

const DEFAULT_CATEGORIES = ['All', 'EXPRESS', 'STANDARD', 'GENERAL'];

const CATEGORY_LABELS = {
  All: 'All',
  EXPRESS: 'Express',
  STANDARD: 'Standard',
  GENERAL: 'General',
};

const SORT_OPTIONS = [
  { value: 'default',        label: 'Default',        icon: '≡' },
  { value: 'cheapest_total', label: 'Cheapest total',  icon: '₹' },
  { value: 'cheapest_kg',    label: 'Cheapest /kg',   icon: '⚖' },
  { value: 'fastest',        label: 'Fastest',         icon: '⚡' },
  { value: 'slowest',        label: 'Slowest',         icon: '⏱' },
];

const FilterForm = ({ onClose }) => {
  const open = true; // always visible as inline panel
  const dispatch = useDispatch();
  const filtersdata    = useSelector((state) => state?.filter?.filterdata);
  const appliedFilters = useSelector((state) => state?.filter?.filters);

  const airlines =
    filtersdata?.carriers?.map((carrier, index) => ({
      id: index + 1,
      name: typeof carrier === 'string' ? carrier : carrier?.name,
      carrcode: carrier?.carrcode || carrier,
    })) || [];

  const stoppages =
    filtersdata?.stops?.map((stop, index) => ({
      id: index + 1,
      label: stop,
    })) || [];

  // Safe slider bounds — guard undefined and min===max (zero-range = non-draggable)
  const hasSliderData =
    filtersdata?.ratePerKiloRange?.min != null &&
    filtersdata?.ratePerKiloRange?.max != null;

  const rateMin     = filtersdata?.ratePerKiloRange?.min ?? 0;
  const rateMaxRaw  = filtersdata?.ratePerKiloRange?.max ?? 0;
  const rateMax     = rateMaxRaw <= rateMin ? rateMin + 1 : rateMaxRaw;

  const priceMin    = filtersdata?.priceRange?.min ?? 0;
  const priceMaxRaw = filtersdata?.priceRange?.max ?? 0;
  const priceMax    = priceMaxRaw <= priceMin ? priceMin + 100 : priceMaxRaw;

  const durMin      = Math.floor((filtersdata?.travelTimeRange?.min ?? 0) / 60);
  const durMaxRaw   = Math.ceil((filtersdata?.travelTimeRange?.max ?? 0) / 60);
  const durMax      = durMaxRaw <= durMin ? durMin + 1 : durMaxRaw;

  // ===== State =====
  const [selectedAirlines, setSelectedAirlines] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [selectedStops, setSelectedStops]        = useState([]);
  const [rateRange, setRateRange]                = useState([0, 1]);
  const [priceRange, setPriceRange]              = useState([0, 100]);
  const [durationRange, setDurationRange]        = useState([0, 1]);
  const [selectedSort, setSelectedSort]          = useState('default');
  // True once the user manually drags a slider thumb (before applying).
  // Prevents streaming bound updates from overwriting an in-progress selection.
  const [slidersTouched, setSlidersTouched]      = useState(false);

  const [serviceTypes, setServiceTypes] = useState([]);

  const fetchServices = async () => {
    if (selectedCategory === 'All') {
      setServiceTypes([]);
      return;
    }
    try {
      const res = await httpinstance.get(`/service-type/${selectedCategory}`);
      const fetched = res.data?.data?.data;
      setServiceTypes(Array.isArray(fetched) ? fetched : []);
    } catch (err) {
      console.error('Failed to fetch services:', err);
      setServiceTypes([]);
    }
  };

  useEffect(() => {
    if (open) fetchServices();
  }, [open, selectedCategory]);

  // Restore state when drawer opens. Depends only on open/hasSliderData so that
  // background filterdata streaming updates never reset the user's in-progress selection.
  useEffect(() => {
    if (!open || !hasSliderData) return;

    if (appliedFilters?.filtersset) {
      // Restore previously applied slider ranges
      setRateRange([
        appliedFilters.ratePerKg?.min  ?? rateMin,
        appliedFilters.ratePerKg?.max  ?? rateMax,
      ]);
      setPriceRange([
        appliedFilters.totalPrice?.min ?? priceMin,
        appliedFilters.totalPrice?.max ?? priceMax,
      ]);
      setDurationRange([
        appliedFilters.journeyDuration?.minHours ?? durMin,
        appliedFilters.journeyDuration?.maxHours ?? durMax,
      ]);

      // Restore stops — applied filter stores labels, match back to stoppages objects
      const restoredStops = appliedFilters.stops?.length
        ? stoppages.filter((s) => appliedFilters.stops.includes(s.label))
        : [];
      setSelectedStops(restoredStops);

      // Restore airlines — applied filter stores names, match back to airline objects
      const restoredAirlines = appliedFilters.airlines?.length
        ? airlines.filter((a) => appliedFilters.airlines.includes(a.name))
        : [];
      setSelectedAirlines(restoredAirlines);

      setSelectedCategory(appliedFilters.category ?? 'All');
      setSelectedSort(appliedFilters.sortBy ?? 'default');
    } else {
      // No previous filters — initialize everything to full range
      setRateRange([rateMin, rateMax]);
      setPriceRange([priceMin, priceMax]);
      setDurationRange([durMin, durMax]);
      setSlidersTouched(false);
      setSelectedStops([]);
      setSelectedAirlines([]);
      setSelectedCategory('All');
      setSelectedSort('default');
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, hasSliderData]);

  // As socket data streams in, bounds widen. Keep the slider thumbs at the full
  // range while the user hasn't manually touched them and no filter is applied.
  // This prevents the "thumbs stuck at first-batch range while track grew wider" bug.
  useEffect(() => {
    if (!hasSliderData || appliedFilters?.filtersset || slidersTouched) return;
    setRateRange([rateMin, rateMax]);
    setPriceRange([priceMin, priceMax]);
    setDurationRange([durMin, durMax]);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rateMin, rateMax, priceMin, priceMax, durMin, durMax]);

  const getFilteredServiceNames = () => {
    if (!Array.isArray(serviceTypes) || serviceTypes.length === 0) return [];
    if (selectedCategory === 'All') return serviceTypes.map((s) => s.servicename);
    return serviceTypes
      .filter((s) => s.category === selectedCategory)
      .map((s) => s.servicename);
  };

  const availableCategories = DEFAULT_CATEGORIES;

  const handleApplyFilters = () => {
    // Only treat a range as an active filter when the user actually narrowed it.
    // Storing the full-range snapshot is fragile: streaming rates keep widening the
    // live bounds, so an un-narrowed snapshot would later look "changed" and surface a
    // phantom chip. null = full range → no chip, no filtering.
    const rateNarrowed  = rateRange[0]     > rateMin  || rateRange[1]     < rateMax;
    const priceNarrowed = priceRange[0]    > priceMin || priceRange[1]    < priceMax;
    const durNarrowed   = durationRange[0] > durMin   || durationRange[1] < durMax;

    const appliedFilters = {
      filtersset      : true,
      airlines        : selectedAirlines?.map((a) => a?.name),
      services        : getFilteredServiceNames(),
      category        : selectedCategory === 'All' ? null : selectedCategory,
      stops           : selectedStops.map((s) => s?.label),
      ratePerKg       : rateNarrowed  ? { min: rateRange[0],  max: rateRange[1] }  : null,
      totalPrice      : priceNarrowed ? { min: priceRange[0], max: priceRange[1] } : null,
      journeyDuration : durNarrowed   ? { minHours: durationRange[0], maxHours: durationRange[1] } : null,
      sortBy          : selectedSort === 'default' ? null : selectedSort,
    };
    dispatch(setFilters(appliedFilters));
    onClose();
  };

  const handleResetFilters = () => {
    setSelectedAirlines([]);
    setSelectedCategory('All');
    setSelectedStops([]);
    setRateRange([rateMin, rateMax]);
    setPriceRange([priceMin, priceMax]);
    setDurationRange([durMin, durMax]);
    setSelectedSort('default');
    setSlidersTouched(false);
    dispatch(setFilters({
      filtersset      : false,
      airlines        : [],
      services        : [],
      category        : null,
      stops           : [],
      ratePerKg       : null,
      totalPrice      : null,
      journeyDuration : null,
      sortBy          : null,
    }));
    onClose();
  };

  // ===== UI =====
  return (
    <Box
      className="filterFormRoot"
      sx={{
        width: '100%',
        backgroundColor: '#ffffff',
        borderRadius: 2,
        border: '1px solid #f0ede8',
        boxSizing: 'border-box',
      }}
    >
      <Box className="filterFormScroll">

        {/* ── Airline Section ── */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 1 }}>
          <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>
            Airline
          </Typography>
        </Box>

        <Autocomplete
          multiple
          options={airlines}
          getOptionLabel={(option) => option?.name}
          value={selectedAirlines}
          onChange={(e, v) => setSelectedAirlines(v)}
          isOptionEqualToValue={(o, v) => o?.id === v?.id}
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder="Select airlines"
              size="small"
              inputProps={{ ...params.inputProps, readOnly: true }}
            />
          )}
        />

        <Divider sx={{ my: 2 }} />

        {/* ── Service Type Section ── */}
        <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>
          Services
        </Typography>

        <RadioGroup
          value={selectedCategory}
          onChange={(e) => {
            e.stopPropagation();
            setSelectedCategory(e.target.value);
          }}
        >
          {availableCategories.map((cat) => (
            <FormControlLabel
              key={cat}
              value={cat}
              control={
                <Radio
                  size="small"
                  sx={{ color: '#ffaf00', '&.Mui-checked': { color: '#ffaf00' } }}
                />
              }
              label={<Typography variant="body2">{CATEGORY_LABELS[cat] ?? cat}</Typography>}
            />
          ))}
        </RadioGroup>

        <Divider sx={{ my: 2 }} />

        {/* ── Sort Results By Section ── */}
        <Typography variant="subtitle2" sx={{ mb: 1.5, fontWeight: 600 }}>
          Sort Results By
        </Typography>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '8px',
            mb: 0.5,
          }}
        >
          {SORT_OPTIONS.map((opt) => {
            const isSelected = selectedSort === opt.value;
            return (
              <Box
                key={opt.value}
                onClick={() => setSelectedSort(opt.value)}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  padding: '8px 10px',
                  border: isSelected ? '2px solid #ffaf00' : '1.5px solid #e0e0e0',
                  borderRadius: '8px',
                  backgroundColor: isSelected ? '#fff9eb' : 'white',
                  cursor: 'pointer',
                  transition: 'border-color 0.08s, background-color 0.08s',
                  '&:hover': { borderColor: '#ffaf00', backgroundColor: '#fff9eb' },
                  userSelect: 'none',
                }}
              >
                {/* Radio dot */}
                <Box
                  sx={{
                    width: 16,
                    height: 16,
                    borderRadius: '50%',
                    border: isSelected ? '2px solid #ffaf00' : '2px solid #bbb',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0,
                    transition: 'border-color 0.08s',
                  }}
                >
                  {isSelected && (
                    <Box
                      sx={{
                        width: 8,
                        height: 8,
                        borderRadius: '50%',
                        backgroundColor: '#ffaf00',
                      }}
                    />
                  )}
                </Box>
                {/* Icon */}
                <Typography
                  sx={{
                    fontSize: '14px',
                    lineHeight: 1,
                    flexShrink: 0,
                    color: isSelected ? '#856404' : '#888',
                  }}
                >
                  {opt.icon}
                </Typography>
                {/* Label */}
                <Typography
                  variant="caption"
                  sx={{
                    fontSize: '0.72rem',
                    fontWeight: isSelected ? 700 : 400,
                    color: isSelected ? '#856404' : '#444',
                    lineHeight: 1.2,
                  }}
                >
                  {opt.label}
                </Typography>
              </Box>
            );
          })}
        </Box>

        <Divider sx={{ my: 2 }} />

        {/* ── Stops Section ── */}
        <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>
          Stops
        </Typography>

        <Autocomplete
          multiple
          options={stoppages}
          getOptionLabel={(option) => option?.label}
          value={selectedStops}
          onChange={(e, v) => setSelectedStops(v)}
          isOptionEqualToValue={(o, v) => o?.id === v?.id}
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder="Select stops"
              size="small"
              inputProps={{ ...params.inputProps, readOnly: true, style: { cursor: 'pointer' } }}
            />
          )}
        />

        <Divider sx={{ my: 2 }} />

        {/* ── Rate/kg Slider ── */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>Rate/kg</Typography>
          <Box sx={{ backgroundColor: '#f7f8f9', borderRadius: 2, px: 1.5, py: 0.3 }}>
            <Typography variant="caption" sx={{ color: 'black', fontWeight: 500 }}>
              Rs/kg {rateRange[0].toFixed(2)} to Rs/kg {rateRange[1].toFixed(2)}
            </Typography>
          </Box>
        </Box>
        <Slider
          value={rateRange}
          sx={{ color: '#ffaf00' }}
          onChange={(_, v) => { setRateRange(v); setSlidersTouched(true); }}
          min={rateMin}
          max={rateMax}
          step={0.01}
          disabled={!hasSliderData}
          valueLabelDisplay="auto"
        />
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: -1 }}>
          <Typography variant="caption" color="text.secondary">Rs/kg {rateMin.toFixed(2)}</Typography>
          <Typography variant="caption" color="text.secondary">Rs/kg {rateMax.toFixed(2)}</Typography>
        </Box>

        <Divider sx={{ my: 2 }} />

        {/* ── Total Price Slider ── */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>Total Price</Typography>
          <Box sx={{ backgroundColor: '#f7f8f9', borderRadius: 2, px: 1.5, py: 0.3 }}>
            <Typography variant="caption" sx={{ color: 'black', fontWeight: 500 }}>
              {priceRange[0].toLocaleString('en-IN')} Rs to {priceRange[1].toLocaleString('en-IN')} Rs
            </Typography>
          </Box>
        </Box>
        <Slider
          sx={{ color: '#ffaf00' }}
          value={priceRange}
          onChange={(_, v) => { setPriceRange(v); setSlidersTouched(true); }}
          min={priceMin}
          max={priceMax}
          step={100}
          disabled={!hasSliderData}
          valueLabelDisplay="auto"
        />
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: -1 }}>
          <Typography variant="caption" color="text.secondary">{priceMin.toLocaleString('en-IN')} Rs</Typography>
          <Typography variant="caption" color="text.secondary">{priceMax.toLocaleString('en-IN')} Rs</Typography>
        </Box>

        <Divider sx={{ my: 2 }} />

        {/* ── Journey Duration Slider ── */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>Journey Duration</Typography>
          <Box sx={{ backgroundColor: '#f7f8f9', borderRadius: 2, px: 1.5, py: 0.3 }}>
            <Typography variant="caption" sx={{ color: 'black', fontWeight: 500 }}>
              {durationRange[0]}h to {durationRange[1]}h
            </Typography>
          </Box>
        </Box>
        <Slider
          sx={{ color: '#ffaf00' }}
          value={durationRange}
          onChange={(_, v) => { setDurationRange(v); setSlidersTouched(true); }}
          min={durMin}
          max={durMax}
          step={1}
          disabled={!hasSliderData}
          valueLabelDisplay="auto"
        />
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: -1 }}>
          <Typography variant="caption" color="text.secondary">{durMin}h</Typography>
          <Typography variant="caption" color="text.secondary">{durMax}h</Typography>
        </Box>

      </Box>

      {/* ── Action Buttons (fixed footer, does not scroll) ── */}
      <Box className="filterFormFooter">
        <Button
          variant="outlined"
          sx={{ color: 'black', borderColor: 'black', padding: '5px 12px', textTransform: 'capitalize' }}
          fullWidth
          onClick={handleResetFilters}
        >
          Reset
        </Button>
        <Button
          variant="contained"
          sx={{ backgroundColor: '#ffaf00', color: 'white', padding: '5px 12px', textTransform: 'capitalize' }}
          fullWidth
          onClick={handleApplyFilters}
        >
          Apply Filters
        </Button>
      </Box>
    </Box>
  );
};

export default FilterForm;